import type { AwsVpcConnectivityConfig } from '@repo/api-gw-sdk';

import ConfirmationDialog from '@/components/dialogs/confirmationDialog';

export function DeleteVpcConfigDialog(props: {
  isOpen: boolean;
  config: AwsVpcConnectivityConfig | undefined;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const { isOpen, onCancel, onConfirm, config } = props;

  return (
    <ConfirmationDialog
      isOpen={isOpen}
      title='Delete customized settings'
      description={
        <>
          {'All customized settings for '}
          <b>{config?.vpc}</b>
          {
            ' will be removed. The restore server will use the default subnets and security groups.'
          }
        </>
      }
      onCancel={onCancel}
      onConfirm={onConfirm}
      confirmSnackbarText={`Deleted customized VPC settings for ${config?.vpc}.`}
      buttonTitle='Delete'
    />
  );
}
